<section>
  <div class="body-container">
    <div class="create-order-container">
      <create-supplies-order></create-supplies-order>
    </div>

    <div class="orders-container">
      <section>
        <h2 class="t-widgetAccentTitle">
          {{ "translate.supplies.ordersList" | translate
          }}{{ selectedClinicTitle }}
        </h2>

        <div
          *ngIf="supplyOrders && supplyOrders.length == 0 && !ordersLoading"
          role="alert"
          class="c-alert t-alert-info"
        >
          {{ "translate.alert.noResults" | translate }}
        </div>

        <loader *ngIf="ordersLoading"></loader>

        <ui-table
          *ngIf="supplyOrders && supplyOrders.length"
          [isWrapped]="false"
          [data]="supplyOrders"
          [dense]="false"
          [tblRoundBottom]="true"
          [numberOfRows]="numberOfRows"
          [totalRecords]="orderSearchMetaData.totalRecords"
          (requestUpdate)="loadDataOnPagination($event)"
          [selectedRow]="selectedOrder"
          [paginatorPosition]="'bottom'"
          [displayFilter]="displayColumnsList"
          [templates]="[
            {
              title: 'translate.general.createUserName',
              template: createUserName,
              permission: labUserSw,
              colClass: 'ui-p-7'
            },
            {
              title: 'translate.general.approveUserName',
              template: approveUserName,
              permission: labUserSw,
              colClass: 'ui-p-7'
            },
            {
              colClass: 'l-ta-center',
              title: 'translate.general.actions',
              template: actions,
              permission: displayActionTemplate,
            },
            {
              colClass: 'l-ta-center',
              title: 'translate.supplies.deliveryEmailStatus',
              template: delivery_email,
              permission: displayActionTemplate,
            }
          ]"
          [colSet]="[
            {
              key: 'city',
              colClass: 'ui-p-7'
            },
            {
              key: 'notes',
              colClass: 'ui-p-6'
            }
          ]"
        ></ui-table>

        <ng-template #createUserName let-row="row">
          <span *ngIf="!row.labCreateSw"
            ><i class="c1 fas fa-user-circle"></i>&nbsp;</span
          >
          {{ row.createUserName }}
        </ng-template>

        <ng-template #approveUserName let-row="row">
          {{ row.approveUserName }}
        </ng-template>

        <ng-template #actions let-row="row">
          <button
            *ngIf="allowedApprove && row.statusCode == 'OPEN'"
            class="t-button-outline btn-approve"
            [class.warn]="row.isBarcodeRollOrder"
            (click)="onApproveClicked(row)"
            [disabled]="row.approveOrderLoading"
          >
            <span *ngIf="!row.isBarcodeRollOrder">
              {{ "translate.supplies.approveOrder" | translate }}</span
            >
            <span *ngIf="row.isBarcodeRollOrder">
              {{ "translate.supplies.scanPublicBatch" | translate }}</span
            >
          </button>
        </ng-template>

        <ng-template #delivery_email let-row="row">
          <div *ngIf="row.isDeliveryOrder">
            <div *ngIf="row.statusCode != 'OPEN'">
              <!--mail icon-->
              <i
                *ngIf="row.mailSentTimestamp && row.deliveryEmail"
                class="fas fa-envelope c-success"
                [tooltip]="row.deliveryEmail"
              ></i>
              <i
                *ngIf="!row.mailSentTimestamp && row.deliveryEmail"
                class="fas fa-envelope c-warn"
                [tooltip]="row.deliveryEmail"
              ></i>
              &nbsp;
              <!--api icon-->
              <i
                *ngIf="row.apiSendStatusSw"
                class="fas fa-desktop c-success"
              ></i>
              <a
                *ngIf="
                  !row.apiSendStatusSw && row.apiSendStatusCode != 'UNKNOWN'
                "
                (click)="approveOrder(row)"
                ><i class="fas fa-desktop c-warn"></i>&nbsp;
                {{ "translate.general.retry" | translate }}
              </a>
            </div>
            <p class="api-type">{{ row.apiType }}</p>
          </div>
        </ng-template>
      </section>
    </div>
  </div>
</section>

<modal-popup
  *ngIf="displayPublicBatchScan"
  [flexible]="true"
  [hideHeader]="true"
  [focusOnOpen]="false"
  (onClose)="displayPublicBatchScan = false"
  [isOpen]="true"
>
  <section class="w-full">
    <header class="l-flex l-align-y l-align-spaceBetween">
      <h2 class="t-widgetTitle">
        {{ "translate.supplies.scanPublicBatch" | translate }}
      </h2>
      <i
        class="fas fa-times t-popupCloseIcon"
        (click)="displayPublicBatchScan = false"
      ></i>
    </header>
    <hr />
  </section>
  <div class="popup-container">
    <input-wrap
      [label]="'translate.supplies.publicBatchCode' | translate"
      cssClass="l-cell-spread"
      [required]="true"
    >
      <input
        class="t-input t-input--colored"
        type="text"
        [(ngModel)]="publicBatchId"
      />
    </input-wrap>
  </div>

  <div class="popup-footer">
    <button
      [disabled]="!publicBatchId"
      (click)="approveOrder(selectedOrder)"
      class="t-button--success"
    >
      {{ "translate.alert.approve" | translate }}
    </button>
  </div>
</modal-popup>
